const modules = import.meta.globEager([
  "~/pages/views/next-js/wrappers/MainHeaderBannerWrapper.tsx",
  "~/pages/views/next-js/wrappers/MainNavigationWrapper.tsx",
  "~/pages/views/next-js/wrappers/FooterWrapper.tsx",
]);

export default modules;
